import { lazy } from "react";

const HelpCenterV2 = lazy(() => import("features/HelpCenter/v2"));

export const HELP_CENTER_PATH = "/help-center";

// V2 Routes
export const HELP_CENTER_V2_PATH = "/account/help-center";

export const helpcenterRoutesV2 = [
  {
    path: HELP_CENTER_V2_PATH,
    component: <HelpCenterV2 />,
  },
];
